import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { Subscription } from 'rxjs';
import { globals } from '../globals';
import { Configuracao } from '../models/configuracao';
import { Contato } from '../models/contato';
import { Funcionario } from '../models/funcionario';
import { Ibge } from '../models/ibge';
import { ViaCep } from '../models/viacep';
import { AppConfigService } from '../services/app-config.service';
import { CarregandoService } from '../services/carregando.service';
import { ContatoService } from '../services/contato.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { IbgeService } from '../services/ibge.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ViaCepService } from '../services/via-cep.service';
import { AnexoCadastroModalComponent } from '../modals/anexo-cadastro-modal/anexo-cadastro-modal.component';
import { AnexoCadastro } from '../models/anexo-cadastro';
import { ContatoAnexoService } from '../services/contato-anexo.service';
import { ArquivoContratoService } from '../services/arquivo-contrato.service';
import { Documento } from '../models/documento';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { DocumentosService } from '../services/documentos.service';
import { Signatario } from '../models/signatario';
import { CadastrarSignatarioModalComponent } from '../modals/cadastrar-signatario-modal/cadastrar-signatario-modal.component';
import { ConsultaCnpjService } from "../core/services/consulta-cnpj.service";
import { Router } from "@angular/router";

// jquery
declare const $: any;

@Component({
  selector: "app-cadastro",
  templateUrl: "./cadastro.component.html",
  styleUrls: ["./cadastro.component.scss"],
})
export class CadastroComponent implements OnInit {
  // variáveis
  contato = new Contato();
  editando = false;
  carregando = true;

  idVisual: any;

  enviouContato = false;
  possuiVenda = false;

  tiposDePessoa = [
    { id: 1, nome: "FÍSICA" },
    { id: 0, nome: "JURÍDICA" },
  ];

  isentoIE = false;

  public MASKS = MASKS;
  editavel = true;
  mascara = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  };
  estados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];

  estadoSelecionado = undefined;

  versao = environment.appVersion;

  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;
  vendedores: Funcionario[] = [];

  mostrarVendedores = false;

  anexos: AnexoCadastro[] = [];

  concordaContratoParceria = false;

  customPatterns = {
    V: { pattern: new RegExp("(,|[0-9]|-|\\.)") },
    0: { pattern: new RegExp("[0-9]") },
  };

  private nativeElement: Node;
  private configuracaoSubscription$: Subscription;
  configuracao: Configuracao;

  urls = [];
  urlSelecionada = globals.apiUrl;
  permitirPessoaFisica: true;

  existeArquivoContrato = false;
  erroDocumentosObrigatorios = false;
  abriuModalAnexo = false;
  documentos: Documento[];

  anoAtual: Number;

  inscricaoEstadualObg = false;

  idTipoDocumentoContato = 0;

  pNomeContratoParceria = "";
  pUsarDocuSign = false;

  signatarios: Signatario[] = [];
  preencherTelEmailConsCnpj: boolean = true;

  @ViewChild("contatoForm", { static: true }) public contatoForm: NgForm;

  constructor(
    private notificacaoService: NotificacaoService,
    private element: ElementRef,
    private contatoService: ContatoService,
    private router: Router,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private viaCepService: ViaCepService,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private funcionarioService: FuncionarioService,
    private appConfigService: AppConfigService,
    private premissasService: PremissasService,
    public dialog: MatDialog,
    private contatoAnexoService: ContatoAnexoService,
    private arquivoContratoService: ArquivoContratoService,
    private documentoService: DocumentosService,
    private premissaService: PremissasService,
    private consultaCnpjService: ConsultaCnpjService
  ) {
    this.nativeElement = element.nativeElement;

    this.idVisual = JSON.parse(localStorage.getItem("idVisual"));
  }

  ngOnInit() {
    this.anoAtual = new Date().getFullYear();
    this.urls = this.appConfigService.getServerUrls();

    if (!this.urls.some((p) => p === this.urlSelecionada)) {
      this.urlSelecionada = undefined;
    }

    if (this.urls.length > 0) {
      this.urlSelecionada = this.urls[0];

      globals.apiUrl = this.urlSelecionada;
      localStorage.setItem("urlApi", this.urlSelecionada);
    }

    this.buscarPremissaUsarDocuSign();
    this.buscarPremissaNomeContratoParceria();

    this.buscarInscricaoEstadualObg();
    this.buscarExisteArquivoContrato();
    this.buscarMostrarVendedores();
    this.buscarDocumentosAnexo();

    this.contato = new Contato();
    this.contato.tipo = 0;
    this.verificarPessoaFisica();

    this.atualizaDadosContato();
    this.buscarPreencherTelEmailConsCnpj();

    // inscreve no evento de troca de configuração
    this.configuracaoSubscription$ =
      this.globalService.alterouConfiguracao.subscribe((conf) => {
        this.configuracao = conf;
      });

    // const body = document.getElementsByTagName('body')[0];
    // // body.classList.add('login-page');
    // // body.classList.add('off-canvas-sidebar');
    // const card = document.getElementsByClassName('card')[0];
    // setTimeout(function () {
    //   // after 1000 ms we add the class animated to the login/register card
    //   card.classList.remove('card-hidden');
    // }, 700);
  }

  buscarPreencherTelEmailConsCnpj() {
    this.carregandoService.mostra("buscarPremissasSistema");

    this.premissasService
      .consultarPreencherTelefoneEmailConsultaCnpj()
      .subscribe(
        (resp) => {
          this.preencherTelEmailConsCnpj = resp;
          this.carregandoService.esconde("buscarPremissasSistema");
        },
        (erro) => {
          this.carregandoService.esconde("buscarPremissasSistema");
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarExisteArquivoContrato() {
    this.carregandoService.mostra("buscarExisteArquivoContrato");

    this.arquivoContratoService.existeArquivoContrato().subscribe(
      (existeArquivoContrato) => {
        this.existeArquivoContrato = existeArquivoContrato;
        // this.erroDocumentosObrigatorios = existeArquivoContrato;

        this.carregandoService.esconde("buscarExisteArquivoContrato");
      },
      (err) => {
        this.carregandoService.esconde("buscarExisteArquivoContrato");
        this.notificacaoService.erro(err);
      }
    );
  }

  alteraUrl() {
    globals.apiUrl = this.urlSelecionada;
    localStorage.setItem("urlApi", this.urlSelecionada);
  }

  buscarVendedores() {
    this.carregandoService.mostra("buscarVendedores");

    this.funcionarioService.consultarFuncionariosContatos().subscribe(
      (dados) => {
        this.vendedores = dados;
        this.carregandoService.esconde("buscarVendedores");
      },
      (erro) => {
        this.carregandoService.esconde("buscarVendedores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  verificarPessoaFisica() {
    this.carregandoService.mostra("verificarPessoaFisica");
    this.premissasService.consultarCadastrarPessoaFisica().subscribe(
      (dados) => {
        this.permitirPessoaFisica = dados.valor;
        if (!this.permitirPessoaFisica) {
          this.contato.tipo = 0;
        }
        this.carregandoService.esconde("verificarPessoaFisica");
      },
      (erro) => {
        this.carregandoService.esconde("verificarPessoaFisica");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarInscricaoEstadualObg() {
    this.carregandoService.mostra("buscarInscricaoEstadualObg");
    this.premissasService.consultarInscricaoEstadualObg().subscribe(
      (dados) => {
        this.inscricaoEstadualObg = dados.valor;
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
      },
      (erro) => {
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
        this.notificacaoService.erro(erro);
      }
    );
  }

  focalizaNumero() {
    $("#numero").focus();
  }

  ngAfterViewInit(): void {
    this.rodaScriptTabEnter();
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosContato() {
    // this.contato.dtNasc = new DatePipe('pt-BR').transform(this.contato.dtNasc, 'MM-dd-yyyy');
    // this.contato.dtAbert = new DatePipe('pt-BR').transform(this.contato.dtAbert, 'y-MM-dd');

    // this.contato.dtNasc = this.contato.dtNasc ? new Date(this.contato.dtNasc).toISOString() : undefined;
    // this.contato.dtAbert = this.contato.dtAbert ? new Date(this.contato.dtAbert).toISOString() : undefined;
    this.estadoSelecionado = this.estados.find((s) => s === this.contato.uf);

    // this.tipoSelecionado = this.tipos.find(s => s === this.contato.tipo);

    this.rodaScriptTabEnter();

    this.buscarVendedores();
    this.buscarCidades();

    this.carregandoService.esconde("buscaContato");
    this.carregando = false;
  }

  salvar() {
    this.carregandoService.mostra("salvaContato");
    this.contato.uf = this.estadoSelecionado;
    this.contato.ibge = this.cidadeSelcionado;
    this.contato.aceitouContrato = this.concordaContratoParceria;

    if (this.pUsarDocuSign) {
      if (!this.signatarios || this.signatarios.length === 0) {
        this.notificacaoService.erro(
          "É necessário cadastrar ao menos um signatário para o contrato!"
        );
        return;
      }

      this.contato.signatariosJson = JSON.stringify(this.signatarios);
    }

    this.contato.cidade = this.cidades.find((s) => s.cod === this.contato.ibge)
      ? this.cidades.find((s) => s.cod === this.contato.ibge).cidade
      : "";

    this.contatoService.salvar(this.contato).subscribe(
      (idContato: number) => {
        for (let [index, anexo] of this.anexos.entries()) {
          if (!anexo.selectedFile) {
            continue;
          }

          this.carregandoService.mostra("salvaAnexo" + index);
          const dados = new FormData();
          dados.append("arquivo_consulta", anexo.selectedFile);
          dados.append("arqui[arquivo]", anexo.selectedFile.name);

          dados.append("arqui[id]", "0");
          dados.append("arqui[idAnexo]", "0");
          dados.append("arqui[descricao]", anexo.descricao);
          dados.append("arqui[idContato]", idContato.toString());

          if (anexo.contrato) {
            dados.append("arqui[contrato]", anexo.contrato.toString());
          }

          if (anexo.idDocumento) {
            dados.append("arqui[idDocumento]", anexo.idDocumento.toString());
          }

          this.contatoAnexoService.salvar(dados).subscribe(
            () => {
              this.carregandoService.esconde("salvaAnexo" + index);
            },
            (erro) => {
              this.carregandoService.esconde("salvaAnexo" + index);
              this.notificacaoService.erro(erro);
            }
          );
        }

        // this.notificacaoService.sucesso('Contato salvo com sucesso!!!');
        this.carregandoService.esconde("salvaContato");
        this.enviouContato = true;
      },
      (erro) => {
        this.carregandoService.esconde("salvaContato");
        this.notificacaoService.erro(erro);
      }
    );
  }

  ngOnDestroy(): void {
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove("login-page");
    body.classList.remove("off-canvas-sidebar");
    this.configuracaoSubscription$.unsubscribe();
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra("buscaEnderecoPorCep");
    this.viaCepService.obterEndereco(this.contato.cep).subscribe(
      (viaCep: ViaCep) => {
        this.contato.bairro = viaCep.bairro;
        // this.contato.compl = viaCep.complemento;
        this.contato.logradouro = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.contato.ibge = viaCep.ibge;

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde("buscaEnderecoPorCep");
      },
      (erro) => {
        this.contato.bairro = "";
        // this.cliente.compl = viaCep.complemento;
        this.contato.logradouro = "";
        this.estadoSelecionado = undefined;
        this.contato.ibge = "";
        this.cidadeSelcionado = undefined;
        this.carregandoService.esconde("buscaEnderecoPorCep");
        this.notificacaoService.erro(
          "Não foi possível acessar o serviço de CEP!"
        );
      }
    );
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra("buscaCidades");
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges;

        if (nomeCidade) {
          this.cidadeSelcionado = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(
                s.cidade.toLowerCase().trim()
              ) ===
              this.utilitarioService.remover_acentos_espaco(
                nomeCidade.toLowerCase().trim()
              )
          )
            ? this.cidades.find(
                (s) =>
                  this.utilitarioService.remover_acentos_espaco(
                    s.cidade.toLowerCase().trim()
                  ) ===
                  this.utilitarioService.remover_acentos_espaco(
                    nomeCidade.toLowerCase().trim()
                  )
              ).cod
            : undefined;
        } else {
          this.cidadeSelcionado = this.cidades.find(
            (s) => s.cod === this.contato.ibge
          )
            ? this.cidades.find((s) => s.cod === this.contato.ibge).cod
            : undefined;
        }
        this.carregandoService.esconde("buscaCidades");
      },
      (erro) => {
        this.carregandoService.esconde("buscaCidades");
      }
    );
  }

  voltar() {
    this.router.navigate(["/login"]);
  }

  consultarCnpj() {
    this.carregandoService.mostra("consultarCnpj");

    this.consultaCnpjService.consultar(this.contato.cnpj).subscribe(
      (data) => {
        const resultado = data.result;
        const registroEstadual = resultado.registrosEstaduais
          ? resultado.registrosEstaduais.find((r) => r.uf === resultado.uf)
          : null;

        let telefone: string | null = null;

        if (resultado.telefones && resultado.telefones.length > 0) {
          telefone = resultado.telefones[0];
        }

        let email: string | null = null;

        if (resultado.emails && resultado.emails.length > 0) {
          email = resultado.emails[0];
        }

        this.contato.cnpj = resultado.cnpj;
        this.contato.razao = resultado.razaoSocial;
        this.contato.fantasia = resultado.nomeFantasia
          ? resultado.nomeFantasia
          : resultado.razaoSocial;

        this.contato.logradouro = resultado.logradouro;
        this.contato.nume =
          resultado.numero != null
            ? resultado.numero.toString()
            : this.contato.nume;
        this.contato.comp = resultado.complemento != null ? resultado.complemento : this.contato.comp;
        this.contato.bairro = resultado.bairro;
        this.contato.ibge = undefined;
        this.estadoSelecionado = resultado.uf;
        this.contato.cep = resultado.cep;

        this.buscarCidades(resultado.cidade);

        if (this.preencherTelEmailConsCnpj) {
          this.contato.telefone = telefone != null ? telefone : this.contato.telefone;
          this.contato.email = email != null ? email : this.contato.email;
        }

        this.contato.listaCnaes = resultado.atividadesEconomicas.map((x) => x.codigo);
        this.contato.optanteSimples = resultado.simples != null ? resultado.simples.optante : null;
        this.contato.dataSituacaoSimples = resultado.simples != null ? resultado.simples.desde : null;
        this.contato.optanteSimei = resultado.simei != null ? resultado.simei.optante : null;
        this.contato.dataSituacaoSimei = resultado.simei != null ? resultado.simei.desde : null;
        this.contato.inscEst = registroEstadual != null ? registroEstadual.ie : this.contato.inscEst;

        this.contato.dataAtualizacaoReceita = resultado.ultimaAtualizacao ? new Date(resultado.ultimaAtualizacao) : new Date(Date.now());
        this.contato.fonteAtualizacaoReceita = resultado.fonte;

        this.carregandoService.esconde("consultarCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("consultarCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }

  verificaCNPJ() {
    !this.contato.cnpj.includes("_") ? this.consultarCnpj() : null;
  }

  verificaCep() {
    if (!this.contato.cep.includes("_")) this.buscarEnderecoPorCep();
  }

  buscarMostrarVendedores() {
    this.carregandoService.mostra("buscarMostrarVendedores");
    this.premissasService.consultarMostrarVenContato().subscribe(
      (f) => {
        this.mostrarVendedores = f.valor;
        this.carregandoService.esconde("buscarMostrarVendedores");
      },
      (erro) => {
        this.carregandoService.esconde("buscarMostrarVendedores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  atualizarCep() {
    window.open("https://viacep.com.br/cep/", "_blank");

    // const largura = Number(($('body').width()));

    // const dialogRef = this.dialog.open(AtualizaCepModalComponent, {
    //   width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((result: any) => {

    // });
  }

  abrirModalAnexos() {
    const largura = Number($("body").width());
    const dialogRef = this.dialog.open(AnexoCadastroModalComponent, {
      width: largura > 1600 ? "1690px" : $("body").width().toString() + "px",
      data: {
        anexos: this.anexos,
        documentos: this.documentos,
        // existeArquivoContrato: this.existeArquivoContrato
      },
      disableClose: true,
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.anexos = result.anexos;
      this.documentos = result.documentos;
      this.erroDocumentosObrigatorios = result.erroDocumentosObrigatorios;
      this.abriuModalAnexo = true;
    });
  }

  buscarDocumentosAnexo() {
    this.carregandoService.mostra("buscarDocumentosAnexo");

    this.documentoService
      .consultarDocumentos(this.idTipoDocumentoContato)
      .subscribe(
        (docs) => {
          this.documentos = docs;

          this.erroDocumentosObrigatorios = this.verificarSeTemObrigatorio();

          this.carregandoService.esconde("buscarDocumentosAnexo");
        },
        (err) => {
          this.carregandoService.esconde("buscarDocumentosAnexo");
          this.notificacaoService.erro(err);
        }
      );
  }

  verificarSeTemObrigatorio() {
    return this.documentos.find((doc) => doc.obrigatorio === true)
      ? true
      : false;
  }

  gerarContrato($event, contatoForm) {
    $event.preventDefault();
    if (!contatoForm.valid) {
      swal({
        title: "Atenção!!",
        text: "Para baixar o contrato é necessário preencher todos os campos obrigatórios",
        type: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonClass: "btn btn-danger",
        cancelButtonText: "Fechar",
        buttonsStyling: false,
      }).then(() => {
        this.concordaContratoParceria = false;
        return;
      });

      return;
    }

    this.carregandoService.mostra("gerarContrato");
    this.contato.uf = this.estadoSelecionado;
    this.contato.ibge = this.cidadeSelcionado;
    this.contato.cidade = this.cidades.find((s) => s.cod === this.contato.ibge)
      ? this.cidades.find((s) => s.cod === this.contato.ibge).cidade
      : "";

    if (this.pUsarDocuSign) {
      if (!this.signatarios || this.signatarios.length === 0) {
        this.notificacaoService.erro(
          "É necessário cadastrar ao menos um signatário para o contrato!"
        );
        return;
      }

      this.contato.signatariosJson = JSON.stringify(this.signatarios);
    }

    this.arquivoContratoService.gerarContrato(this.contato).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, "ContratoParceria.pdf");
        this.carregandoService.esconde("gerarContrato");
      },
      (erro) => {
        this.carregandoService.esconde("gerarContrato");
        this.notificacaoService.erro(erro);
      }
    );
  }

  changeConcordaContrato(contatoForm) {
    if (!contatoForm.valid) {
      swal({
        title: "Atenção!!",
        text: "Para aceitar o contrato e baixar é necessário preencher todos os campos obrigatórios",
        type: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonClass: "btn btn-danger",
        cancelButtonText: "Fechar",
        buttonsStyling: false,
      }).then(() => {
        this.concordaContratoParceria = false;
      });
    }
  }

  buscarPremissaNomeContratoParceria() {
    this.carregandoService.mostra("buscarPremissaNomeContratoParceria");

    this.premissaService.consultarNomeContratoParceria().subscribe(
      (pNomeContratoParceria) => {
        this.pNomeContratoParceria = pNomeContratoParceria.valor;
        this.carregandoService.esconde("buscarPremissaNomeContratoParceria");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaNomeContratoParceria");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaUsarDocuSign() {
    this.carregandoService.mostra("buscarPremissaUsarDocuSign");

    this.premissaService.consultarUsarDocuSign().subscribe(
      (pUsarDocuSign) => {
        this.pUsarDocuSign = pUsarDocuSign.valor;
        this.carregandoService.esconde("buscarPremissaUsarDocuSign");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaUsarDocuSign");
        this.notificacaoService.erro(erro);
      }
    );
  }

  novoSignatario() {
    const largura = Number($("body").width());
    const dialogRef = this.dialog.open(CadastrarSignatarioModalComponent, {
      width: largura > 830 ? "800px" : $("body").width().toString() + "px",
      data: {
        cadastroContato: true,
        listaCpfs:
          this.signatarios.length > 0
            ? this.signatarios.map((c) => c.cpf)
            : null,
      },
      panelClass: "modal-card",
      maxHeight: "90vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.signatarios.push(result);
      }
    });
  }

  excluir(sigIndex) {
    this.signatarios.splice(sigIndex, 1);
  }
}
